import { render, staticRenderFns } from "./FallbackSwitch.vue?vue&type=template&id=bc4e3ab0&scoped=true&lang=pug&"
import script from "./FallbackSwitch.vue?vue&type=script&lang=js&"
export * from "./FallbackSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4e3ab0",
  null
  
)

export default component.exports